import type { TFunction } from "i18next";

export const comparedStageLabel = (t: TFunction, comparedRound: number | null | undefined): string | null =>
  comparedRound == null
    ? null
    : comparedRound === 0
      ? t("the initial tenders")
      : t("negotiation round {{round}}", { round: comparedRound });
